import { Action } from '@ngrx/store';

import { VerifierState } from '../shared-state.interface';
import { VerifierActions, VerifierActionTypes } from './pkce-verifier.actions';

export const emptyVerifierState: VerifierState = {
    pkceVerifier: null
};

export const initialVerifierState: VerifierState = emptyVerifierState;

export function verifierReducer(state = initialVerifierState, action: Action): VerifierState {
    const specificAction: VerifierActions = action as VerifierActions;
    switch (specificAction.type) {
        case VerifierActionTypes.Set:
            return { pkceVerifier: specificAction.payload };

        case VerifierActionTypes.Unset:
            return { ...emptyVerifierState };

        default:
            return state;
    }
}
